<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc-title"><span class="bbold">Table of Contents</span></h2>
<p class="toc-chapter"><a href="#/xhtml/chap01"><span class="toc-no">Chapter 1:</span> Are You Frustrated?</a></p>
<p class="toc-chapter"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="toc-no">Chapter 2:</span> Who Am I to Help You?</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="toc-no">Chapter 3:</span> What You’ll Get</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="toc-no">Chapter 4:</span> Jesus, Take the Wheel</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="toc-no">Chapter 5:</span> Just Breathe</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="toc-no">Chapter 6:</span> Words are Powerful</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="toc-no">Chapter 7:</span> Seven Silent Languages</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="toc-no">Chapter 8:</span> The Law of Reflection and the Epiphany Approach</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="toc-no">Chapter 9:</span> Take a Hand</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="toc-no">Chapter 10:</span> Sending Forth</span></p>
<p class="toc-bmt"><span href="#/xhtml/bm01" title="Link target outside of Sample"><span class="titalic">My Prayer for You</span></span></p>
<p class="toc-bm"><span href="#/xhtml/bm02" title="Link target outside of Sample"><span class="titalic">Acknowledgements</span></span></p>
<p class="toc-bm"><span href="#/xhtml/bm03" title="Link target outside of Sample"><span class="titalic">Thank You</span></span></p>
<p class="toc-bm"><span href="#/xhtml/bm04" title="Link target outside of Sample"><span class="titalic">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5da42fe6